import { inject, InjectionToken } from "@angular/core";
import { Router } from "@angular/router";
import { RouterService } from "../_services/router.service";
import { saveBrokerConnection } from "./broker-connection";

// A refused sign-in comes back with the reason in errorcode and errordescription; passing them on lets the sign-in
// page show it.
export type SignInReason = {
    errorcode: string;
    errordescription?: string;
};

// Where a signed-out visitor goes, given the address asked for. The website has a sign-in page of its own; the
// dashboard has none and provides its own way to the website's.
export type SignInRedirect = (requestedUrl: string, reason?: SignInReason) => void;

export const SIGN_IN_REDIRECT = new InjectionToken<SignInRedirect>("SIGN_IN_REDIRECT", {
    factory: (): SignInRedirect => {
        const router = inject(RouterService);
        const angularRouter = inject(Router);
        // Refused while the page first opens, the visit leaves its address as the browser's current entry, and Back
        // would return to it (a spent sign-in says "did not start in this browser tab"); the sign-in page replaces it.
        // A broker connection that came back to a signed-out tab, or whose token was refused, finishes after the sign-in.
        return (requestedUrl: string, reason?: SignInReason): void => {
            saveBrokerConnection(angularRouter, requestedUrl);
            router.navigate("/sign-in", reason, !angularRouter.navigated);
        };
    },
});
